"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateBlogNotificationEmailsRequestStatus = exports.getDeleteBlogRequestStatus = exports.getUpdateBlogRequestStatus = exports.getCreateBlogRequestStatus = exports.getFetchBlogsRequestStatus = exports.getBlogHasConnectedDomain = exports.getBlogHasNotificationEmails = exports.getDefaultBlogId = exports.getBlogIds = exports.getBlogFromRoute = exports.getBlogsAsSelectInputOptions = exports.getBlogs = void 0;

var _immutable = require("immutable");

var _selectors = require("settings-ui-sdk/Routes/selectors");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _selectors2 = require("settings-ui-sdk/UserSettings/selectors");

var _selectors3 = require("settings-ui-sdk/Domains/selectors");

var _reselect = require("reselect");

var _getDefaultBlogIdFromBlogsMap = _interopRequireDefault(require("./getDefaultBlogIdFromBlogsMap"));

var getBlogs = function getBlogs(state) {
  return state.modules.website.blogs.entities.blogs;
};

exports.getBlogs = getBlogs;
var getBlogsAsSelectInputOptions = (0, _reselect.createSelector)([getBlogs], function (blogs) {
  return blogs.reduce(function (acc, blog) {
    acc.push({
      value: blog.get('id'),
      text: blog.get('name')
    });
    return acc;
  }, []);
});
exports.getBlogsAsSelectInputOptions = getBlogsAsSelectInputOptions;
var getBlogFromRoute = (0, _reselect.createSelector)([getBlogs, _selectors.getLastNumericTokenFromPath], function (blogs, blogId) {
  return blogs.get(blogId);
});
exports.getBlogFromRoute = getBlogFromRoute;
var getBlogIds = (0, _reselect.createSelector)([getBlogs], function (blogs) {
  return blogs.toArray().map(function (blog) {
    return blog.get('id');
  });
});
exports.getBlogIds = getBlogIds;
var getDefaultBlogId = (0, _reselect.createSelector)([getBlogs, _selectors2.getFavoriteBlog, getBlogIds], function (blogs, favoriteBlog, blogIds) {
  return blogIds.includes(favoriteBlog) ? favoriteBlog : (0, _getDefaultBlogIdFromBlogsMap.default)(blogs);
});
exports.getDefaultBlogId = getDefaultBlogId;
var getBlogHasNotificationEmails = (0, _reselect.createSelector)([getBlogFromRoute], function (blog) {
  return !!blog.get('subscriptionContactsProperty');
});
exports.getBlogHasNotificationEmails = getBlogHasNotificationEmails;
var getBlogHasConnectedDomain = (0, _reselect.createSelector)([getBlogFromRoute, _selectors3.getBlogDomains], function (blog, blogDomains) {
  var domainName = blog.get('resolvedDomain');
  var blogDomain = blogDomains.find(function (domain) {
    return domain.get('domain') === domainName;
  }) || (0, _immutable.Map)();
  return blogDomain.get('isDnsCorrect') && blogDomain.get('isResolving');
});
exports.getBlogHasConnectedDomain = getBlogHasConnectedDomain;
var getFetchBlogsRequestStatus = (0, _getRequestStatus.default)(_actions.BlogActionTypes.FETCH_BLOGS);
exports.getFetchBlogsRequestStatus = getFetchBlogsRequestStatus;
var getCreateBlogRequestStatus = (0, _getRequestStatus.default)(_actions.BlogActionTypes.CREATE_BLOG);
exports.getCreateBlogRequestStatus = getCreateBlogRequestStatus;
var getUpdateBlogRequestStatus = (0, _getRequestStatus.default)(_actions.BlogActionTypes.UPDATE_BLOG);
exports.getUpdateBlogRequestStatus = getUpdateBlogRequestStatus;
var getDeleteBlogRequestStatus = (0, _getRequestStatus.default)(_actions.BlogActionTypes.DELETE_BLOG);
exports.getDeleteBlogRequestStatus = getDeleteBlogRequestStatus;
var getCreateBlogNotificationEmailsRequestStatus = (0, _getRequestStatus.default)(_actions.BlogActionTypes.CREATE_BLOG_NOTIFICATION_EMAILS);
exports.getCreateBlogNotificationEmailsRequestStatus = getCreateBlogNotificationEmailsRequestStatus;